import { Tooltip } from 'components/ui/tooltip';
import { CaseClosingConfigurationDto } from 'types/caseClosing';
import { t } from 'utils/getTranslations';
import { CaseClosingSubsection, CaseClosingTick } from './CaseClosingSubsection';
import { useCaseClosingSubsectionEdit } from './useCaseClosingSubsectionEdit';

const ALWAYS_ON_CONDITION_IDS = ['no-uninvoiced-hours', 'no-uninvoiced-expenses'];

interface Props {
    caseClosing: CaseClosingConfigurationDto;
}

export function ClosingConditionsSubsection({ caseClosing }: Props) {
    const { isEditMode, isSaving, startEditing, cancel, change, valueOf, save } =
        useCaseClosingSubsectionEdit(caseClosing);

    return (
        <CaseClosingSubsection
            titleId="case-closing-config.closing-conditions"
            isEditMode={isEditMode}
            isSaving={isSaving}
            onEdit={startEditing}
            onCancel={cancel}
            onSave={() => {
                void save();
            }}
        >
            <p className="text-body2 text-fg-secondary">{t('case-closing-config.closing-conditions-intro')}</p>
            {ALWAYS_ON_CONDITION_IDS.map((conditionId) => (
                <CaseClosingTick
                    key={conditionId}
                    label={t(`case-closing-config.${conditionId}`)}
                    checked
                    disabled
                    trailing={
                        <Tooltip content={t('case-closing-config.always-on-tooltip')}>
                            <span className="text-body2 text-fg-secondary">{t('case-closing-config.always-on')}</span>
                        </Tooltip>
                    }
                />
            ))}
            <CaseClosingTick
                label={t('case-closing-config.no-unfinished-tasks')}
                checked={valueOf('requiresNoUnfinishedTasks')}
                disabled={!isEditMode}
                onCheckedChange={(checked) => change({ requiresNoUnfinishedTasks: checked })}
            />
            <CaseClosingTick
                label={t('case-closing-config.no-unsettled-invoices')}
                helperText={t('case-closing-config.no-unsettled-invoices-helper')}
                checked={valueOf('requiresNoUnsettledInvoices')}
                disabled={!isEditMode}
                onCheckedChange={(checked) => change({ requiresNoUnsettledInvoices: checked })}
            />
            <CaseClosingTick
                label={t('case-closing-config.no-unused-prepayments')}
                helperText={t('case-closing-config.no-unused-prepayments-helper')}
                checked={valueOf('requiresNoUnusedPrepayments')}
                disabled={!isEditMode}
                onCheckedChange={(checked) => change({ requiresNoUnusedPrepayments: checked })}
            />
        </CaseClosingSubsection>
    );
}
